module.exports = __webpack_public_path__ + "img/cookies-8416230_1280.c1162908.jpg";